<template>
  <div>
    <pc v-if="isMobile === 2" />
    <mobile v-if="isMobile === 1" />
  </div>
</template>

<script>
  import pc from './pc/homePc.vue'
  import mobile from './m/homeMobile.vue'
  export default {
    name: "home",
    data() {
      return {
        isMobile: -1
      };
    },
    components: { pc, mobile },
    mounted() {
      this.isMobile = this._isMobile();
    },
    methods: {
      _isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        );
        return flag?1:2;
      },
    },
  };
</script>